import { createRoot } from 'react-dom/client';
import BasketIconButton, {
    BasketIconButtonVariant,
} from 'src/widgets/activities/basket-icon/BasketIconButton';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';

class BilberryBasketIcon extends BilberryCustomElement {
    protected renderWidget(): void {
        const size = this.getAttribute('size')?.toLowerCase();
        const xsSize = this.getAttribute('xs-size')?.toLowerCase();
        const variantText = this.getAttribute('variant')?.toLowerCase();

        // Parse unified hide-text attribute with backward compatibility
        const hideTextValue = this.getAttribute('hide-text')?.toLowerCase();
        const smallOnMobile = this.getAttribute('small-on-mobile');

        // Deprecation warning for old attribute
        if (smallOnMobile) {
            // eslint-disable-next-line no-console
            console.warn(
                'Deprecation warning: "small-on-mobile" attribute is deprecated. ' +
                    'Use "hide-text=mobile" instead. This attribute will be removed in a future version.',
            );
        }

        let hideTextMode: 'all' | 'mobile' | 'no' = 'no';

        if (hideTextValue === 'all' || hideTextValue === 'mobile') {
            hideTextMode = hideTextValue;
        } else if (hideTextValue === 'yes') {
            hideTextMode = 'all';
        } else if (smallOnMobile === 'yes') {
            hideTextMode = 'mobile';
        }
        let sizeString: 's' | 'm' | 'l' = 's';
        let xsSizeOrDefault: 's' | 'm' | 'l' = 's';
        const variant =
            variantText === 'dense'
                ? BasketIconButtonVariant.DENSE
                : BasketIconButtonVariant.DEFAULT;

        if (size === 's' || size === 'm' || size === 'l') {
            sizeString = size;
        }

        if (xsSize === 's' || xsSize === 'm' || xsSize === 'l') {
            xsSizeOrDefault = xsSize;
        }

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <BasketIconButton
                    size={sizeString}
                    xsSize={xsSizeOrDefault}
                    hideTextMode={hideTextMode}
                    variant={variant}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-basket-icon', BilberryBasketIcon);
}
